module.exports = __webpack_public_path__ + "img/survey-pattern-bottom.31988502.png";